import React, { Suspense, lazy } from 'react';
import { useInView } from '../hooks/useInView';
// Code-split the WebGL shader bundle so it never blocks first paint.
const LiquidMetal = lazy(() => import('@paper-design/shaders-react').then(mod => ({
  default: mod.LiquidMetal
})));
/**
 * The liquid metal wash behind the VAULT[LAB] call to action. It only mounts
 * while the footer is on screen — a continuously running WebGL canvas is the
 * single most expensive thing on the page, and there is no reason to pay for
 * it while someone is reading the listing.
 */
export function FooterShader() {
  const {
    ref,
    inView
  } = useInView<HTMLDivElement>({
    rootMargin: '300px'
  });
  return <div ref={ref} aria-hidden="true" className="absolute inset-0 z-0 opacity-40 mix-blend-screen pointer-events-none flex items-center justify-center" data-id="element-108" data-mp="27cqx5inyx2nu">
      {inView && <Suspense fallback={null} data-id="element-109" data-mp="2hawxhvu4m0ql">
          <LiquidMetal speed={0.42} softness={0.1} repetition={1.94} shiftRed={0.3} shiftBlue={0.3} distortion={0.07} contour={0.79} scale={0.6} rotation={0} shape="circle" angle={70} frame={849368.655999263} colorBack="#00000000" colorTint="#C8FF00" style={{
        height: '100%',
        width: '100%',
        minHeight: '800px'
      }} data-id="element-110" data-mp="2hbzixo8ojaz4" />
        </Suspense>}
    </div>;
}